<template>

    <div v-show="!showManager" class="home">
        <div class="top-action">
            <top-search :searchtype="searchtype" :keyword.sync="keyword" :keyword-change="keywordChange"></top-search>
            <menu v-if="isShowMenu" :menu-list="menuList" :cateid="cateid" :is-show-menu.sync="isShowMenu"
                  @change="onMenuChange"></menu>
            <navigationbar :menu-list="menuList" :cateid="cateid" :is-show-menu.sync="isShowMenu"
                           @change="onMenuChange"></navigationbar>
        </div>
        <div class="info-msg">
            <slideload :slidemessage="paramArr"></slideload>
        </div>

    </div>
    <search-manager v-show="showManager" v-el:manager></search-manager>

</template>
<style lang="less">
    @import "Home.less";
</style>
<script>
    var daojiaLog = require('../../libs/daojiaLog');
    module.exports = {
        name : 'home',
        data: function () {
            return {
                cateid: null,
                homeNavMessage: "",
                isShowMenu: false,
                searchtype: 'searchRouter',
                keyword: '请输入物品名称等关键词',
                menuList: require('./menuList'),
                showManager: false
            }
        },
        ready : function () {
            daojiaLog({pagetype:'zhuanzhuan_list'},'pageview');
        },
        computed: {
            paramArr: function () {
                return {
                    type: "navData",
                    url: "getRecommendForWeChat",
                    params: {
                        pagenum: 1,
                        pagesize: 10,
                        cateid : this.cateid
                    }
                }
            }
        },
        created : function () {
            var _this = this;

            window.onpopstate = function(event) {
                console.log('popstate')

                _this.showManager = false

            };
        },
        methods: {
            onMenuChange: function (cateid) {
                var route;
                // 如果存在cateid
                if(cateid){
                    route = {
                        name : 'category',
                        params : {
                            cateid : cateid
                        }
                    };
                }
                else{
                    route = {
                        name : 'home',
                        params : {}
                    };
                }
                console.log(route);
                this.$router.go(route);
            },
            keywordChange:function(keyword){
                this.keyword = keyword;
            }
        },
        events: {
            toShowManger : function(){
                this.showManager = true;
            },
            toHideManager : function(){
                this.showManager = false
            }
        },
        components: {
            'slideload': require('../SlideLoad/SlideLoad.vue'),
            'menu': require('./Menu/Menu.vue'),
            'navigationbar': require('./NavigationBar/NavigationBar.vue'),
            'top-search': require('../TopSearch/TopSearch.vue'),
            'search-manager': require('../SearchManager/SearchManager.vue')
        },
        route : {
            deactivate : function () {
                console.log('home:route:deactivate');
                this.showManager = false;
                this.$broadcast('cancelScroll');
            },
            data : function () {
                console.log('home:route:activate');
                document.title = '淘闲置';
                // 设置cateid
                this.$els.manager.style.display = 'none';
                this.cateid = this.$route.params.cateid || null;
                this.$broadcast('startScroll');
                this.$broadcast('getInformation');
            }
        }
    }
</script>



/** WEBPACK FOOTER **
 ** Home.vue?52109db0
 **/